import GlobalCommandMenu from "@/components/command-modal/globalCommandModal";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Level } from "@/gen/auth/common_pb";
import { Loading } from "@/layouts/loading";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import DashboardLayoutWrapper from "./-module-components/layout";

export const Route = createFileRoute('/company/_layout')({
    component: () => (
        <SidebarProvider>
            <DashboardLayoutWrapper>
                <GlobalCommandMenu />
                <Outlet />
            </DashboardLayoutWrapper>
        </SidebarProvider>
    ),
    beforeLoad: async ({ }) => {
        const level = localStorage.getItem("level");
        
        // Only redirect if user doesn't have company-level access
        if (level !== Level.COMPANY.toString()) {
            if (level === Level.BRANCH.toString()) {
                return redirect({
                    to: "/branch/dashboard",
                });
            } else if (level === Level.STOCK_POINT.toString()) {
                return redirect({
                    to: "/overview",
                });
            } else {
                // Default redirect for unknown levels
                return redirect({
                    to: "/branch/dashboard",
                });
            }
        }
        
        // If user has company access, allow them to proceed to their requested route
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
});